// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-user-popover.tooltip.popover .popover-inner{padding:12px;max-width:29rem}.delete-user-popover.tooltip.popover .popover-inner .actions{display:grid;grid-column-gap:1rem;-webkit-column-gap:1rem;-moz-column-gap:1rem;column-gap:1rem;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;grid-template-columns:repeat(2,40%)}", ""]);
// Exports
module.exports = exports;
